import React from 'react';
import authRoles from '../../../auth/authRoles';
import AllRooms from './AllRooms';
import AddSchedules from './AddSchedules';
import UploadSchedules from './UploadSchedules';
import Updateschedule from './updateschedule';
import Roomschedule from './RoomSchedule';
import RoomSettings from './RoomSettings';
import Room from './Room';
import AddRoom from './AddRoom';
import FeedsTypeDetail from './FeedsTypeDetail';
import AddLocation from './AddLocation';

const StudentInformationConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/rooms',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AllRooms />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-addschedules/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddSchedules />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-upload-schedules',
			element: (
				<React.Suspense fallback={<>...</>}>
					<UploadSchedules />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-updateschedule/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Updateschedule />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-roomschedule/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Roomschedule />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-roomsetting/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoomSettings />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-room/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Room />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-addroom',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddRoom />
				</React.Suspense>
			),
		},
		{
			path: '/rooms-FeedsType/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<FeedsTypeDetail />
				</React.Suspense>
			),
		},
		{
			path: '/location-add',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddLocation />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default StudentInformationConfig;
